import type { RfoBannerSettings } from './RfoBannerSettings.types.tsx';

/**
 * A dismissable banner stays dismissed only while the message is unchanged: the RFO service
 * regenerates `hashId` whenever the text changes, which re-shows the banner to everyone who
 * dismissed the previous one.
 *
 * Anonymous users have nowhere to persist a dismissal, so they are never considered dismissed.
 */
export const getIsDismissed = (
	isAnonymous: boolean,
	settings: RfoBannerSettings,
	hashIdLastDismissed: string | null,
): boolean => {
	if (isAnonymous || !settings?.isDismissable) {
		return false;
	}

	return settings?.hashId === hashIdLastDismissed;
};
